module.exports = __webpack_public_path__ + "static/media/OutOfSpecIcon.ce986610.svg";